import React, { useState, useEffect } from "react";
import "./GosevaGallery.css";
import { ArrowRight, ArrowDown } from "lucide-react";
import { Link } from 'react-router-dom';
import { FaArrowDown } from "react-icons/fa";

const gosevaSlides = [
  {
    image: "/assets/home_guaseva/peace.jpg",
    text: "Gauseva brings joy and peace to your home."
  },
  {
    image: "/assets/home_guaseva/couple_happy.jpg",
    text: "It strengthens bonds between husband and wife."
  },
  {
    image: "/assets/home_guaseva/happyness.jpg",
    text: "It invites prosperity, comfort, and inner freedom"
  },
  {
    image: "/assets/home_guaseva/luxury (1).jpg",
    text: "Gauseva leads to a balanced and fulfilling life."
  }
];

const GosevaGallery = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % gosevaSlides.length);
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
    <h2 className="section-title">Unlock the Power of Gauseva in Your Daily Life</h2> 
    <div className="goseva-gallery-container">
       
      {/* Card 1 */}
      <div className="goseva-card">
        
        <img
          src="/assets/Gauseva/Gauseva13.jpeg"
          alt="Do Goseva"
        />
        <p className="goseva-text">
          Who gives Gau Seva, receives power, wealth, and happiness in return.
        </p>
        
      </div>

      {/* Arrow */}
      <div className="goseva-arrow">
        <ArrowRight className="arrow-desktop" size={36} />
        <ArrowDown className="arrow-mobile" size={36} />
      </div>

      {/* Card 2 */}
      <div className="goseva-card">
        <img
          src="/assets/home_guaseva/consult1.jpg"
          alt="Wealth from Goseva"
        />
        <p className="goseva-text">
          Venus blesses those who serve the cow with love, luxury, and strong relationships.
        </p>
        
      </div>

      {/* Arrow */}
      <div className="goseva-arrow">
        <ArrowRight className="arrow-desktop" size={36} />
        <ArrowDown className="arrow-mobile" size={36} />
      </div>

      {/* Card 3 - Slideshow */}
      <div className="goseva-card slideshow-card">
        <img
          src={gosevaSlides[currentSlide].image}
          alt={gosevaSlides[currentSlide].text}
        />
        <p className="goseva-text">{gosevaSlides[currentSlide].text}</p>
         <div className="animated-arrow-gauseva-button">
            <FaArrowDown />
          </div>
        <a href="/Gauseva" className="goseva-button">Donate Now </a>
      </div>
    </div>
  </div>  
  );
};

export default GosevaGallery;
